import CouponSetup from "@commons/coupon-setup";
import React from "react";

const Discount = ({ state }: { state: any }) => {
  
  return <CouponSetup role="store" state={state} />;
};

export default Discount;
